export function farloUiSliderMobile(element) {
  if (!element) return;

  let flkty;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, init);

  const mediaQuery = window.matchMedia('(max-width: 980px)');

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  });

  function init() {
    if (mediaQuery.matches && !flkty) {
      flkty = new Flickity(element, {
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        draggable: true,
        adaptiveHeight: false,
        autoPlay: 4000,
      });

      flkty.on('ready', () => flkty.resize());
      setTimeout(() => flkty.resize(), 100);
    }
  }
}
